import api from '../../api'
import {
  GET_BENEFIT_LIST_SUCCESS,
  GET_BENEFIT_LIST_FAILURE,
  GET_BENEFIT_FAILURE,
  GET_BENEFIT_SUCCESS,
  UPDATE_BENEFIT_SUCCESS,
} from '../types'

const state = {
  list: [],
  listUpdated: (new Date()),
  toValidateList: [],
  selected: null,
  selectedUpdated: (new Date())
};


const actions = {

  
  getBenefitList({commit}, query) {
    return new Promise((resolve, reject) => {

    api.startLoader()
    api.getBenefitList(query).then(response => {
      if (!response.ok) {
        api.stopLoader()
         commit(GET_BENEFIT_LIST_FAILURE)
         return reject(response.body.$error)

      }
      commit(GET_BENEFIT_LIST_SUCCESS, {
        benefitList: response.body.data
      })
      api.stopLoader()
      return resolve(response.body.data)

    }, response => {
      api.stopLoader()
      commit(GET_BENEFIT_LIST_FAILURE)
      return reject(response.body.$error)

    })
  })
  },
 
  cleanBenefitList({commit}) {
    return commit(GET_BENEFIT_LIST_FAILURE)
  },
  
  getBenefit({commit}, ud) {
    return new Promise((resolve, reject) => {

      api.getBenefit(ud)
        .then(response => {
          console.log(response);
          if (!response.ok) {
            commit(GET_BENEFIT_FAILURE);
            reject();
          }
          commit(GET_BENEFIT_SUCCESS, {
            benefit: response.body
          });
          resolve(response.body);
        }, response => {
          commit(GET_BENEFIT_FAILURE);
          reject();
        })
    })
  },
 
  
  updateBenefit({commit}, data) {
    return new Promise((resolve, reject) => {

      api.startLoader()

      if (data.formattedPhone != undefined) {
        data.phone = data.formattedPhone.replace(/[^0-9]/g, '');
      }

      let avaliables = [
        "id",
        "title",
        "description",
        "site",
        "phone"
      ];

      let obj = {};

      for (let i of avaliables) {
        if (data.hasOwnProperty(i)) {
          obj[i] = data[i];
        }
      }

          api.updateBenefit(obj)
            .then(response => {
              if (!response.ok) {
                api.stopLoader()
                return reject(response.body.$error);
              } else {
                api.stopLoader()
                return resolve(response.body.$success);
              }
            }, response => {
              api.stopLoader()
              return reject(response.body.$error);
            })
      
    })
  },
  createBenefit({commit}, data) {
    return new Promise((resolve, reject) => {
      api.startLoader()

      if (data.formattedPhone != undefined) {
        data.phone = data.formattedPhone.replace(/[^0-9]/g, '');
      }

      api.createBenefit(data)
        .then(response => {
          if (!response.ok) {
            api.stopLoader()
            return reject(response.body.$error);
          } else {
            api.stopLoader()
            return resolve(response.body.$success);
          }
        }, response => {
          api.stopLoader()
          return reject(response.body.$error);
        })
    })
  },
  
  
 
  deleteBenefit({commit}, data) {
    return new Promise((resolve, reject) => {
      api.startLoader()
      api.deleteBenefit(data)
        .then(response => {
          if (!response.ok) {
            api.stopLoader()
            return reject(response.body.$error);
          } else {
            api.stopLoader()
            return resolve(response.body.$success);
          }
        }, response => {
          api.stopLoader()
          return reject(response.body.$error);
        })
    })
  },

  
  
};

const mutations = {

  [UPDATE_BENEFIT_SUCCESS](state, action) {
    state.selected = JSON.parse(JSON.stringify(action.benefit));
  },
  [GET_BENEFIT_LIST_FAILURE](state) {
    state.list = []
  },
  [GET_BENEFIT_LIST_SUCCESS](state, action) {
    state.list = action.benefitList;
    state.listUpdated = new Date();
  },
  [GET_BENEFIT_FAILURE](state) {
    state.selected = null
  },
  [GET_BENEFIT_SUCCESS](state, action) {
    state.selected = JSON.parse(JSON.stringify(action.benefit));
  },
};

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/benefit.js